import API from './base';

const version = 'v1';
const payment = '/payment';

export default {
  newPayment(payload) {
    return API.post(`${version}${payment}`, payload);
  },

  createMpApiPayment(payload) {
    return API.post(`${version}${payment}/create`, payload);
  },
};
